import { IAction, IFormSubmitAction, IPayloadAction } from "core/store";
import * as actions from "./actionTypes";
import { IReviewer } from "./model";

interface IActionResetPasswordPayload {
  email: string;
}

export interface IActionSetCurrentReviewer
  extends IPayloadAction<
    typeof actions.SET_CURRENT_REVIEWER,
    IReviewer | null
  > {}
export const setCurrentReviewer = (
  payload: IReviewer | null
): IActionSetCurrentReviewer => ({
  type: actions.SET_CURRENT_REVIEWER,
  payload,
});

export interface IActionSetReviewers
  extends IPayloadAction<typeof actions.SET_REVIEWERS, IReviewer[]> {}
export const setReviewers = (payload: IReviewer[]): IActionSetReviewers => ({
  type: actions.SET_REVIEWERS,
  payload,
});

export interface IActionClearReviewers
  extends IAction<typeof actions.CLEAR_REVIEWERS> {}

export const clearReviewers = (): IActionClearReviewers => ({
  type: actions.CLEAR_REVIEWERS,
});

export interface IActionGetReviewersRequest
  extends IAction<typeof actions.GET_REVIEWERS_REQUEST> {}

export const getReviewersRequest = (): IActionGetReviewersRequest => ({
  type: actions.GET_REVIEWERS_REQUEST,
});

export interface IActionGetReviewerRequest
  extends IAction<typeof actions.GET_REVIEWER_REQUEST> {}

export const getReviewerRequest = (): IActionGetReviewerRequest => ({
  type: actions.GET_REVIEWER_REQUEST,
});

export interface IActionSetIsFetching
  extends IAction<typeof actions.SET_IS_FETCHING_REVIEWERS> {}

export const setIsFetchingReviewers = (): IActionSetIsFetching => ({
  type: actions.SET_IS_FETCHING_REVIEWERS,
});

export interface IActionResetIsFetchingReviewers
  extends IAction<typeof actions.RESET_IS_FETCHING_REVIEWERS> {}

export const resetIsFetchingReviewers =
  (): IActionResetIsFetchingReviewers => ({
    type: actions.RESET_IS_FETCHING_REVIEWERS,
  });

export interface IActionSetIsConfirmActive
  extends IAction<typeof actions.SET_IS_REVIEWER_ACTIVATION_CONFIRM_ACTIVE> {}

export const setIsReviewerActivationConfirmActive =
  (): IActionSetIsConfirmActive => ({
    type: actions.SET_IS_REVIEWER_ACTIVATION_CONFIRM_ACTIVE,
  });

export interface IActionResetIsReviewerActivationConfirmActive
  extends IAction<typeof actions.RESET_IS_REVIEWER_ACTIVATION_CONFIRM_ACTIVE> {}

export const resetIsReviewerActivationConfirmActive =
  (): IActionResetIsReviewerActivationConfirmActive => ({
    type: actions.RESET_IS_REVIEWER_ACTIVATION_CONFIRM_ACTIVE,
  });

interface IActionDeactivateReviewerRequestPayload {
  npi: string;
}

export interface IActionDeactivateReviewerRequest
  extends IPayloadAction<
    typeof actions.DEACTIVATE_REVIEWER_REQUEST,
    IActionDeactivateReviewerRequestPayload
  > {}

export const deactivateReviewerRequest = (
  payload: IActionDeactivateReviewerRequestPayload
): IActionDeactivateReviewerRequest => ({
  type: actions.DEACTIVATE_REVIEWER_REQUEST,
  payload,
});

export interface IActionPasswordResetRequest
  extends IFormSubmitAction<
    typeof actions.PASSWORD_FORM_NAME,
    IActionResetPasswordPayload
  > {}
export const passwordResetRequest = (
  payload: IActionResetPasswordPayload,
  formName: string
): IActionPasswordResetRequest => ({
  type: actions.PASSWORD_FORM_NAME,
  payload,
  form: formName,
});

export interface IActionGetTechnicianPhysiciansRequest
  extends IPayloadAction<
    typeof actions.GET_TECHNICIAN_PHYSICIANS_REQUEST,
    string
  > {}
export const getTechnicianPhysiciansRequest = (
  technicianId: string
): IActionGetTechnicianPhysiciansRequest => ({
  type: actions.GET_TECHNICIAN_PHYSICIANS_REQUEST,
  payload: technicianId,
});

export type TAction =
  | IActionSetCurrentReviewer
  | IActionSetReviewers
  | IActionClearReviewers
  | IActionGetReviewersRequest
  | IActionGetReviewerRequest
  | IActionSetIsFetching
  | IActionResetIsFetchingReviewers
  | IActionSetIsConfirmActive
  | IActionResetIsReviewerActivationConfirmActive
  | IActionDeactivateReviewerRequest
  | IActionPasswordResetRequest
  | IActionGetTechnicianPhysiciansRequest;



// WEBPACK FOOTER //
// ./~/tslint-loader??ref--0!./study_reviewer/src/store/reviewers/actions.ts